<template>
  <div class="form-div">
    <div class="img-box">
      <img src="../../img/study/logo.png" class="img-logo"/>
      <img src="../../img/study/pic01.png" alt="" class="pic"/>
    </div>
    <form action="" ref="formData" class="form">
      <img src="../../img/study/title.png" class="title-pic">
      <div class="num">目前已有近2万+人报名咨询</div>
<!--      <div class="num">目前已有近{{count}}人报名咨询</div>-->
      <div class="u-item">
        <div class="name">姓名</div>
        <input type="text" class="input" v-model="formData.name" id="name"  placeholder="请输入您的姓名"/>
      </div>
      <div class="u-item">
        <div class="name">手机号</div>
        <input
          type="tel"
          id="tel"
          v-validate="'required|isMobile'"
          data-vv-name="手机号码"
          :class="colorShow ? 'input' : 'input yellow-border'"
          v-model="formData.mobile"
          ref="mobileInput"
          @blur="mobileBlur"
          placeholder="请输入您的手机号"
        />
      </div>

      <div class="u-item">
        <div class="name">验证码</div>
        <div
          class="clearfix"
          style="height: 45px; line-height: 56px; width: 100%;display: flex"
        >
        <input
          type="tel"
          class="input"
          style="width: 53.5%"
          v-validate="'required'"
          data-vv-name="验证码"
          v-model="mobileCode"
          ref="codeInput"
          placeholder="请输入"
        />
        <span @click="getCode" class="verification">{{verificationCode}}</span>
        </div>
      </div>
      <div class="u-item">
        <div class="name">留言</div>
        <textarea class="input text-area" v-model="formData.message"  placeholder="请输入"/>
      </div>

<!--      <div class="u-item">-->
<!--        <div class="name">所在城市</div>-->
<!--        <div class="option clearfix">-->
<!--        <select v-model="province">-->
<!--          <option disabled value="">请选择</option>-->
<!--          <option-->
<!--            v-for="(item, index) in areaProvinceList"-->
<!--            :key="index"-->
<!--            v-bind:value="item.areaId"-->
<!--          >-->
<!--          {{ item.areaName }}-->
<!--          </option>-->
<!--        </select>-->
<!--        <select v-model="city">-->
<!--          <option disabled value="">请选择</option>-->
<!--          <option-->
<!--            v-for="(item, index) in areaCityList"-->
<!--            :key="index"-->
<!--            v-bind:value="item.areaId"-->
<!--          >-->
<!--          {{ item.areaName }}-->
<!--          </option>-->
<!--        </select>-->
<!--        <select v-model="formData.area" style="margin-right: 0">-->
<!--          <option disabled value="">请选择</option>-->
<!--          <option-->
<!--            v-for="(item, index) in areaList"-->
<!--            :key="index"-->
<!--            v-bind:value="item.areaId"-->
<!--          >-->
<!--          {{ item.areaName }}-->
<!--          </option>-->
<!--        </select>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="u-item u-trade">-->
<!--        <div class="name">所属行业</div>-->
<!--        <select v-model="formData.trade" id="trade">-->
<!--        <option disabled value="">请选择</option>-->
<!--        <option-->
<!--          v-for="(item, index) in tradeList"-->
<!--          :key="index"-->
<!--          v-bind:value="item.value"-->
<!--        >-->
<!--          {{ item.value }}-->
<!--        </option>-->
<!--        </select>-->
<!--      </div>-->
      <div class="submit" @click="saveAllInfo">立即咨询</div>
      <div class="tip">咨询成功后将通过电话联系您留言</div>
    </form>
    <div class="foot">
      <span>联系地址：北京市海淀区学院南路12号-北京师范 大学京师科技大厦A座13层</span>
    </div>
  </div>
</template>

<script>
import {
  getInsert,
  getTradeList,
  getAreaList,
  getCountList,
  advertisersCallback,
  getCodeFun,
  getVerifyCode,
} from "./apis.js";

export default {
  name: "Index",
  data() {
    return {
      formData: {
        name: "",
        mobile: "",
        // area: "",
        // trade: "",
        message:'', // 留言
        channelCode: '留学新媒体',
        sourceType:"留学新媒体"
      },
      areaProvinceList: [],
      areaList: [],
      areaCityList: [],
      tradeList: [], //所属行业
      areaProvinceId: "",
      areaCityId: "",
      province: "",
      city: "",
      colorShow: true,
      count: 0,
      pValue: "",
      status: true,
      timer: 60,
      verificationCode: "获取验证码",
      codeFocus: false,
      mobileCode: "", //短信验证码
    };
  },
  methods: {
    getCode() {
      if (this.formData.mobile == "") {
        this.$layer.msg("手机号码不能为空", {time: 3});
        this.$refs.mobileInput.focus();
      } else {
        if (
            this.errors.items.length != 0 &&
            this.errors.items[0].field == "手机号码"
        ) {
          this.$layer.msg(this.errors.items[0].msg, {time: 3});
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
        if (this.status) {
          this.status = false;
          var count = this.timer;
          this.verificationCode = count + "s后重新获取";
          var timer = setInterval(() => {
            if (count === 0) {
              clearInterval(timer);
              this.verificationCode = "获取验证码";
              this.status = true;
            } else {
              count--;
              this.verificationCode = count + "s后重新获取";
            }
          }, 1000);
          this.$refs.codeInput.focus();
          this.getSmsCode();
        }
      }
    },
    async getSmsCode() {
      //获取验证码
      try {
        let param = {
          mobile: this.formData.mobile,
        };
        let {data} = await getCodeFun(param);
        if (data.code == 1000) {
          this.$layer.msg(data.message, {time: 3});
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVerifyCode() {
      //验证短信验证码是否正确
      try {
        let param = {
          mobile: this.formData.mobile,
          mobileCode: this.mobileCode,
        };
        let {data} = await getVerifyCode(param);
        if (data.code == 1000) {
          console.log("+++++=");
          console.log("验证短信验证码", data);
          //						this.$layer.msg(data.message, {time: 3});
          this.saveInfo();
        } else {
          console.log("验证码错误");
          this.$layer.msg(data.message, {time: 3});
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveInfo() {
      //保存
      try {
        if (this.formData.name == "") {
          this.$layer.msg(data.message, {time: 3});
        }
        let {data} = await getInsert(this.formData);
        if (data.code == 1000) {
          console.log("保存接口返回的数据", data);
          alert(data.message)
          // var others = {
          //这个参数必须是对象
          // 所属行业: this.formData.trade,
          //							}
          // };
          // sendPage($("#tel").val(), $("#name").val(), others, {});
          this.$layer.msg(data.message, {time: 3});
          // this.advertisersCallback();
        } else {
          this.$layer.msg(data.message, {time: 3});
          //						this.advertisersCallback();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async advertisersCallback() {
      //广告回调
      try {
        let params = {
          p: this.pValue,
        };
        let {data} = await advertisersCallback(params);
        console.log("广告回调返回数据", data);
      } catch (err) {
        console.log(err);
      }
    },
    saveAllInfo() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.getVerifyCode();
        }
        if (this.errors.items[0].rule == "required") {
          this.$layer.msg(`${this.errors.items[0].field}不能为空`, {time: 3});
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
        if (
            this.errors.items.length != 0 &&
            this.errors.items[0].field == "手机号码"
        ) {
          this.$layer.msg(this.errors.items[0].msg, {time: 3});
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
      });
    },
    // async getTradeList() {
    //   let params = {
    //     dictType: "trade_detail",
    //     pageSize: "10000",
    //   };
    //   try {
    //     let {data} = await getTradeList(params);
    //     console.log("所属行业数据", data);
    //     this.tradeList = data.data.content;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async getCountList() {
      //获取人数
      try {
        let {data} = await getCountList();
        this.count = data.data;
      } catch (err) {
        console.log(err);
      }
    },
    mobileBlur() {
      //手机号码input失焦事件
      this.colorShow = true;
    },
    // async getAreaList() {
    //   //获取所在城市
    //   let parentAreaId = "";
    //   if (this.province != "" && this.city == "") {
    //     parentAreaId = this.areaProvinceId;
    //   } else if (this.province != "" && this.city != "") {
    //     parentAreaId = this.areaCityId;
    //   } else {
    //     parentAreaId = "";
    //   }
    //   let params = {
    //     parentAreaId: parentAreaId,
    //     pageSize: "10000",
    //   };
    //   try {
    //     let {data} = await getAreaList(params);
    //     console.log("获取城市数据", data);
    //     if (parentAreaId != "" && this.areaCityId == "") {
    //       this.areaCityList = data.data.content; //获取市
    //     } else if (parentAreaId != "" && this.areaCityId != "") {
    //       this.areaList = data.data.content; //获取县
    //     } else {
    //       this.areaProvinceList = data.data.content; //获取省
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
  },
  // watch: {
  //   province: {
  //     handler: function (val) {
  //       console.log("val", val);
  //       this.areaProvinceId = val;
  //       this.city = "";
  //       this.formData.area = "";
  //       this.getAreaList();
  //     },
  //   },
  //   city: {
  //     handler: function (val) {
  //       console.log("val", val);
  //       this.areaCityId = val;
  //       this.formData.area = "";
  //       this.getAreaList();
  //     },
  //   },
  // },
  mounted() {
    this.getCountList();
    // this.getAreaList();
    // this.getTradeList();
    this.pValue = this.$route.query.p;
    console.log("this.pValue", this.pValue);
  },
};
</script>

<style scoped>
.form-div{
	background:#0086C9;
  padding-bottom: 30px;
}

.img-box {
  width: 100%;
  height: auto;
  position: relative;
}
.img-logo{
  position: absolute;
  top: 30px;
  left: 50%; /* 让左边距为父容器宽度的一半 */
  transform: translateX(-50%); /* 移动自身宽度的一半，实现水平居中 */
  width: 170px;
  height: 45px;
  text-align: center; /* 如果内容是文字，则使其水平居中 */
}

.img-box .pic {
  display: inline-block;
  width: 100%;
}
.form{
  width: 90%;
  margin: 20px auto;
  padding: 20px 0;
  background: #FFFFFF;
  border-radius: 20px;
}
.title-pic{
  width: 280px;
  height: 45px;
  margin-top: -30px;
}
.num{
  font-size: 14px;
  color: #555555;
}
.verification{
  margin-left: 5px;
  width: 40%;
  height: 40px;
  line-height: 40px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #0996DC;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 15px;
  color: #0086C9;
  display: inline-block;
}


.button div {
  width: 30%;
  height: 32px;
  background: #fff;
  display: inline-block;
  float: left;
  text-align: center;
  line-height: 32px;
  margin-left: 10px;
  opacity: 0.7;
  margin-top: 280px;
  border-radius: 12px;
  margin-bottom: 30px;
}

.u-item {
  width: 90%;
  //margin-bottom: 15px;
  margin: 0 auto;
  box-sizing: border-box;
}

.name {
  text-align: left;
  font-size: 15px;
  margin-top: 10px;
  color: #000000;
  margin-bottom: 10px;
}

.input {
  width: 290px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #CCCCCC;
  padding-left: 5px;
}
.text-area{
  height: 131px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #CCCCCC;
  padding: 10px;
  box-sizing: border-box;
}

.option select {
  width: 30%;
  height: 35px;
  float: left;
  border: 1px solid #c6cacc;
  background: #f6fcff;
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 15px;
  outline: none;
  padding-left: 15px;
  margin-right: 5%;
}

.u-trade select {
  width: 100%;
  height: 35px;
  border: 1px solid #c6cacc;
  background: #f6fcff;
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 15px;
  outline: none;
  padding-left: 15px;
}

.submit {
  width: 93%;
  height: 45px;
  background: #0086C9;
  color: #fff;
  font-size: 15px;
  line-height: 45px;
  text-align: center;
  margin: 20px auto;
  border-radius: 6px;
}
.tip{
  font-size: 13px;
  color: #000000;
}
.foot{
  background: url("../../img/study/foot.png") no-repeat;
  width: 92%;
  margin:  0 auto;
  height: 75px;
  background-size: 100% 100%;
}
.foot span{
  margin-top: 20px;
  display: inline-block;
  text-align: left;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
  padding: 0 20px;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/sm/studyAbroad.vue